import React from 'react';
import { TextStyle, ViewStyle } from 'react-native';
import { useTranslation } from 'react-i18next';

import { View, Text } from '@24i/nxg-sdk-quarks';

type EmptyComponentProps = {
    styles: {
        noDataContainer?: ViewStyle;
        noDataTextTitle?: TextStyle;
        noDataTextSubtitle?: TextStyle;
    };
};

const EmptyComponent = ({ styles = {} }: EmptyComponentProps) => {
    const { t } = useTranslation(['sott']);

    return (
        <View style={styles?.noDataContainer}>
            <Text style={styles?.noDataTextTitle}>{t('page.noData.title')}</Text>
            <Text style={styles?.noDataTextSubtitle}>{t('page.noData.subtitle')}</Text>
        </View>
    );
};

export default EmptyComponent;
